import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { theme } from 'app/Theme';
import ContentContainer from '@libComponents/ContentContainer';
import LeavesCard from './LeavesCard';

/**
 * Shared component for displaying remaining leaves summary
 * Can be used with different data fetching strategies and titles
 */
const RemainingLeavesShared = ({ 
    year, 
    title = 'Leaves Summary',
    fetchAction,
    actionPayload = {}
}) => {
    const [data, setData] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            fetchAction({
                payload: { selectedYear: year, ...actionPayload },
                handleSubmit
            })
        );
    }, [year, fetchAction, dispatch]);

    const handleSubmit = (data) => {
        if (data.length) {
            setData(data);
        }
    };

    if (!data) return null;

    return (
        <ContentContainer
            title={title}
            headerBg={theme.palette.background.mainHeader}
            InfoComponent={
                <Box
                    display='flex'
                    alignItems='center'
                    ml='16px'
                    pt={0.3}
                    sx={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: '12px',
                        gap: '2px',
                        padding: '4px 6px'
                    }}
                >
                    <InfoIcon sx={{ fontSize: 14, color: '#555' }} />
                    <Typography
                        variant='body2'
                        sx={{
                            color: '#555',
                            fontSize: '12px',
                            fontWeight: 500
                        }}
                    >
                        Leave Used / Total Leaves
                    </Typography>
                </Box>
            }
        >
            <LeavesCard data={data} />
        </ContentContainer>
    );
};

export default RemainingLeavesShared;
